import React from "react";
import { Row, Col } from "reactstrap";
import { formatDate } from "../../../Utils/format-date.js";
import submitAssessmentImg from "../../../../images/new-images/submitAssessmentImg.png";
import DropDown from "./DropDown/DropDown";
import "./DownloadReports.css";
import Dataloader from "../../Data-loader";
import Button from "../../../Utils/Button/index.jsx";

const Renderselfloireport = (props) => {

  const userName = localStorage.getItem("user_name") === "null" ? "-" : localStorage.getItem("user_name");

  const isReportEnabled = props.assessmentDetails && props.assessmentDetails.enable_report;

  return (
    <div className="report-wrapper">
      {props.dataLoader && <Dataloader loaderText="Downloading your PDF please wait..." />}
      <Row>
        <Col md="8">
          <p className="Congratulations">Congratulations, {userName}!</p>
          <div>
            <p className="You-have-completed-your-self-assessment">Your Report is ready to download</p>
            <div className="assessment-details" style={{ width: "30%" }}>
              <Row>
                <Col md="4">
                  <img
                    className="assessment-Icon"
                    src={
                      localStorage.getItem("baseLink") +
                      `/media/` +
                      (props.assessmentDetails && props.assessmentDetails.instrument__instrument_image)
                    }
                  />
                </Col>
                <Col md="8">
                  <p className="assessment-name">
                    {props.assessmentDetails && props.assessmentDetails.instrument__dashboard_header_text}
                  </p>
                  <p className="participant-name">
                    {props.assessmentDetails && props.assessmentDetails.participant__full_name}
                    <span style={{ textTransform: "lowercase" }}>'s</span>
                    <span style={{ marginLeft: '5px' }}>
                      {props.assessmentDetails && props.assessmentDetails.instrument__instrument_name}
                    </span>
                  </p>
                  <p className="Expiry-date">
                    <span style={{ marginRight: '5px' }}>Expired on</span>
                    {formatDate(props.assessmentDetails && props.assessmentDetails.expiry_date)}
                  </p>
                </Col>
              </Row>
            </div>
          </div>
          <p className="Submit-in-order-to-access-your-detailed-Orientation-Reports">
            Click in order to download your detailed Orientation Reports.
          </p>
          {isReportEnabled ? (
            props.downloadReportDropdown.length === 0 ? (
              <button
                className="submit-button"
                onClick={() =>
                  props.handleSelfReportDownload(
                    props.assessmentDetails.id,
                    props.assessmentDetails.participant__id,
                    props.assessmentDetails.instrument__instrument_name
                  )
                }
              >
                Download
              </button>
            ) : (
              <DropDown
                downloadReportDropdown={props.downloadReportDropdown}
                handlePdfDownload={props.handlePdfDownload}
              />
            )
          ) : (
            <div style={{ display: 'flex', justifyContent: 'center',marginTop:'10px' }}>
              <Button type="disabled report"> Download </Button>
            </div>
          )}
        </Col>
        <Col md="4">
          <div className="flex-wrapper">
            <img className="image" src={submitAssessmentImg} />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Renderselfloireport;


// WEBPACK FOOTER //
// ./src/new/Components/Reports/Download-Reports/Selfloireport.jsx